var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.777778 0.5H13.2222C13.4285 0.5 13.6263 0.581944 13.7722 0.727806C13.9181 0.873667 14 1.0715 14 1.27778V13.7222C14 13.9285 13.9181 14.1263 13.7722 14.2722C13.6263 14.4181 13.4285 14.5 13.2222 14.5H0.777778C0.571498 14.5 0.373667 14.4181 0.227806 14.2722C0.0819442 14.1263 0 13.9285 0 13.7222V1.27778C0 1.0715 0.0819442 0.873667 0.227806 0.727806C0.373667 0.581944 0.571498 0.5 0.777778 0.5ZM1.55556 2.05556V12.9444H12.4444V2.05556H1.55556ZM6.22456 10.6111L2.92444 7.311L4.02422 6.21122L6.22456 8.41156L10.6237 4.01167L11.7242 5.11144L6.22456 10.6111Z",
    fill: "#CBD5E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplete);
export default __webpack_public_path__ + "static/media/complete.f85b585650e4ed530cd6fe6fad0dd03d.svg";
export { ForwardRef as ReactComponent };